var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-213.000000, -1690.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(77.000000, 1131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 40.000000)",
    id: "Section-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.000000, 510.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Categoty-title"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Team",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Person"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,8 C9.47333333,8 10.6666667,6.80666667 10.6666667,5.33333333 C10.6666667,3.86 9.47333333,2.66666667 8,2.66666667 C6.52666667,2.66666667 5.33333333,3.86 5.33333333,5.33333333 C5.33333333,6.80666667 6.52666667,8 8,8 Z M8,9.33333333 C6.22,9.33333333 2.66666667,10.2266667 2.66666667,12 L2.66666667,13.3333333 L13.3333333,13.3333333 L13.3333333,12 C13.3333333,10.2266667 9.78,9.33333333 8,9.33333333 Z",
    id: "Shape",
    fill: "#8298AB",
    fillRule: "nonzero"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.52c6fe24.svg";
export { ForwardRef as ReactComponent };